import { render, staticRenderFns } from "./ScrapProductsInventory.vue?vue&type=template&id=39533a52&scoped=true&"
import script from "./ScrapProductsInventory.vue?vue&type=script&lang=js&"
export * from "./ScrapProductsInventory.vue?vue&type=script&lang=js&"
import style0 from "./ScrapProductsInventory.vue?vue&type=style&index=0&id=39533a52&prod&lang=css&"
import style1 from "./ScrapProductsInventory.vue?vue&type=style&index=1&id=39533a52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39533a52",
  null
  
)

export default component.exports